module.exports = __webpack_public_path__ + "static/media/Anil Mathew Resume.c2405841.pdf";